import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from "@mui/material";
export const createAtlasTabScrollButton = ({ LeftIcon, RightIcon }, tokens) => {
    const { semantic: { color }, component: { tabs: { scrollButton }, }, } = tokens;
    const TabScrollButton = (props) => {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { slots, slotProps, disabled, direction } = props, otherProps = __rest(props, ["slots", "slotProps", "disabled", "direction"]);
        return (_jsxs(Button, Object.assign({ sx: {
                width: scrollButton.width.value,
                paddingLeft: 0,
                paddingRight: 0,
                // making sure it resizes to different tab heights
                height: "auto",
                flexShrink: 0,
            } }, otherProps, { children: [direction === "left" && (_jsx(LeftIcon, { color: disabled ? color.text.disabled.value : scrollButton.icon.color.value })), direction === "right" && (_jsx(RightIcon, { color: disabled ? color.text.disabled.value : scrollButton.icon.color.value }))] })));
    };
    return TabScrollButton;
};
//# sourceMappingURL=createAtlasTabScrollButton.js.map